var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.starArticleList.length > 0
    ? _c(
        "div",
        {
          staticClass: "fancafe_recommend",
          attrs: { id: "fancafe_recommend" },
        },
        [
          _c(
            "div",
            { staticClass: "inner_recommend", attrs: { id: "recommend" } },
            [
              _c("div", { staticClass: "group_panel" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "wrap_btn" }, [
                  _c(
                    "button",
                    {
                      ref: "prevButton",
                      staticClass: "btn_g btn_prev",
                      class: { btn_disabled: this.curPage === 0 },
                      attrs: {
                        disabled: this.curPage === 0,
                        id: "recommendPrev",
                      },
                      on: { click: _vm.slidePrev },
                    },
                    [
                      _c("span", { staticClass: "ico_cafetop" }, [
                        _vm._v("이전 보기"),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      ref: "nextButton",
                      staticClass: "btn_g btn_next",
                      class: { btn_disabled: this.curPage === this.maxPage },
                      attrs: {
                        disabled: this.curPage === this.maxPage,
                        id: "recommendNext",
                      },
                      on: { click: _vm.slideNext },
                    },
                    [
                      _c("span", { staticClass: "ico_cafetop" }, [
                        _vm._v("다음 보기"),
                      ]),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "wrap_list" }, [
                _c(
                  "ul",
                  {
                    ref: "listEl",
                    staticClass: "track_list",
                    attrs: { id: "recommendList" },
                  },
                  _vm._l(_vm.starArticleList, function (starArticle, index) {
                    return _c(
                      "star-article-item",
                      _vm._b(
                        { key: "star-article-" + index },
                        "star-article-item",
                        starArticle,
                        false
                      )
                    )
                  }),
                  1
                ),
              ]),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "recommend_title fandom" }, [
      _c("span", { staticClass: "txt_state" }, [_vm._v("FROM. STAR")]),
      _vm._v(" "),
      _c("strong", { staticClass: "tit_recommend" }, [
        _vm._v("공식팬카페 "),
        _c("em", [_vm._v("스타가 남긴 글")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }